import {EventEmitter, Injectable, Output} from "@angular/core";

/**
 * Service provided by each search page to enable events to be sent to search fields.
 */
@Injectable()
export class SearchPageService {

    /**
     * Event triggered when the search page is refreshed
     * @type {EventEmitter}
     */
    @Output() pageRefreshed: EventEmitter<boolean> = new EventEmitter();

    /**
     * Event triggered when a search page refresh is requested
     * @type {EventEmitter}
     */
    @Output() pageRefreshRequested: EventEmitter<boolean> = new EventEmitter();

    /**
     * Allows the search page to inform the search grid whether it can handle view/edit actions for the entity.
     */
    public canOpenEntity: boolean;

    /**
     * Send a page refresh requested event
     */
    requestRefresh(): void {
        this.pageRefreshRequested.emit(true);
    }

    /**
     * Send a page refreshed event
     */
    notifyRefresh(): void {
        this.pageRefreshed.emit(true);
    }
}
